import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { motion, useMotionValueEvent, useScroll } from "framer-motion";

import images from '../libs/images';
import consts from '../libs/consts';
import routes from '../libs/routes';

import { useUser, useMenu, usePopup, useHeader } from "../zustand/store.js";
import { numFormat, useWindowSize } from '../utils/utils';

import { LangText } from "../zustand/dict.js";


export default function LeftNavCredit(props) {

    const {
        isOpen,
    } = props;

    const anim = {
        open: { x: 0, display: "block" },
        close: { x: "100%", display: "none" }
    }

    const navigate = useNavigate();
    const location = useLocation();

    const { user } = useUser();

    const linkFunc = (link) => {
        if (link) {
            navigate(link);
        }
    }



    return (
        <>
            <motion.div
                style={{
                    position: "absolute",
                    left: 0,
                    top: 0,
                    width: "100%",
                    height: "100%",
                    background: "white",
                    zIndex: 101
                }}
                initial={anim.close}
                animate={isOpen ? anim.open : anim.close}
                exit={{ x: "100%" }}
                transition={{ duration: 0.2 }}
                onClick={() => {

                }}
            >
                {/* <div style={{ padding: 16 }} className='etc_list'>
                    <p className='body2 color-g300'>
                        <LangText id={'text_remaining_credit'} />
                    </p>
                    <div className='top'>
                        <div className='credits_left'>
                            <p className='body1 comment'>{numFormat(user?.point)}</p>
                        </div>
                        <Link className='link_text body2' to={routes.pay}>
                            <LangText id={'text_buy'} />
                        </Link>
                    </div>
                    <ul className='list'>
                        <li>
                            <Link className='body1 title link' to={routes.pay_history}>
                                <LangText id={'usage history'} />
                            </Link>
                        </li>
                    </ul>
                </div> */}
                <div
                    className='language_list'
                    style={{
                        padding: 16,
                        display: "flex",
                        flexDirection: "column",
                    }}>

                    <p style={{ cursor: "auto" }} className='body2 color-g300'>
                        <LangText id={'text_remaining_credit'} />
                    </p>
                    <p style={{
                        display: "flex",
                        width: "100%",
                        justifyContent: "space-between",
                        cursor: "auto"
                    }} onClick={() => { }}>
                        {numFormat(user?.point)}
                        <span className='body2 color-sec pointer' onClick={() => {
                            navigate(routes.pay)
                        }}><LangText id={'text_buy'} /></span>
                    </p>
                    <hr style={{
                        margin: "8px 0px"
                    }} />
                    <p style={{
                        width: "100%",
                    }} onClick={() => {
                        navigate(routes.pay_history)
                    }}><LangText id={'usage history'} /></p>
                </div>
            </motion.div>
        </>
    )
}